import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  firstName: string,
  lastName: string,
  email: string,
}

const initialState: UserState = {
  firstName: '',
  lastName: '',
  email: '',
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (
      state,
      action: PayloadAction<UserState>
    ) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.email = action.payload.email;
    },
  },
});

export const { updateUser } = userSlice.actions;
export default userSlice.reducer;
